package top.wcpe.allincore.ui.runtime.ir

import top.wcpe.allincore.ui.runtime.internal.log.UiLog
import kotlin.jvm.JvmField

private val DSL_LOGGER = UiLog("top.wcpe.allincore.ui.runtime.ir.DslLogger")

/**
 * DSL 内建 `print(expr)` / `log(expr)` 的输出端。
 *
 * 默认实现保留历史字段名 [STDOUT]，实际写入平台日志门面（JVM 委托 SLF4J）；测试可注入捕获实现。
 */
interface DslLogger {

    /** 写入一条 print 消息（典型用法：玩家可见的调试输出）。 */
    fun print(message: String)

    /** 写入一条 log 消息（典型用途：开发者日志，可单独路由）。 */
    fun log(message: String)

    companion object {
        /** 默认实现：通过正式日志输出，避免游戏日志出现 STDOUT 噪声。 */
        @JvmField
        val STDOUT: DslLogger = object : DslLogger {
            override fun print(message: String) {
                DSL_LOGGER.info("[DSL] $message")
            }

            override fun log(message: String) {
                DSL_LOGGER.debug("[DSL] $message")
            }
        }

        /** 工具：基于回调构造一个统一处理的 logger（print/log 都走同一通道）。KMP 迁移后回调改函数类型，Kotlin lambda 调用面零改动。 */
        fun ofConsumer(sink: (String) -> Unit): DslLogger = object : DslLogger {
            override fun print(message: String) {
                sink(message)
            }

            override fun log(message: String) {
                sink(message)
            }
        }
    }
}
